import { useState } from "react";
import { stamp, type StampStyle } from "@shared/lib/format";
import { Dialog, Field } from "@shared/ui/bits";
import { Button } from "@shared/ui/button";
import { Input } from "@shared/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@shared/ui/select";

const STYLES: StampStyle[] = ["R", "f", "F", "t", "T", "d", "D"];

/** Значение для `datetime-local`: местное время без пояса, с точностью до минуты. */
function localValue(at: Date): string {
  const shifted = new Date(at.getTime() - at.getTimezoneOffset() * 60_000);
  return shifted.toISOString().slice(0, 16);
}

/** Через час, ровно на начало часа: «сбор в восемь» чаще, чем «в 19:43». */
function nextHour(): Date {
  const at = new Date();
  at.setHours(at.getHours() + 1, 0, 0, 0);
  return at;
}

/**
 * Окно «Вставить время»: дата и вид, в поле ввода ложится `<t:…:вид>`. Каждый
 * читающий увидит её в своём часовом поясе — так в Discord договариваются о
 * времени, не пересчитывая «по Москве».
 */
export function StampDialog({ onPick, onClose }: { onPick: (token: string) => void; onClose: () => void }) {
  const [value, setValue] = useState(() => localValue(nextHour()));
  const [style, setStyle] = useState<StampStyle>("R");

  const at = value ? new Date(value) : null;
  const valid = at !== null && !Number.isNaN(at.getTime());

  return (
    <Dialog
      title="Вставить время"
      onClose={onClose}
      actions={
        <>
          <Button type="button" variant="secondary" onClick={onClose}>
            Отмена
          </Button>
          <Button
            type="button"
            disabled={!valid}
            onClick={() => {
              if (!valid) return;
              onPick(`<t:${Math.floor(at.getTime() / 1000)}${style === "f" ? "" : `:${style}`}>`);
              onClose();
            }}
          >
            Вставить
          </Button>
        </>
      }
    >
      <div className="poll-form">
        <Field label="Когда">
          <Input type="datetime-local" value={value} onChange={(event) => setValue(event.target.value)} />
        </Field>
        <Field label="Как показать" hint="Каждый увидит время в своём часовом поясе.">
          <Select value={style} onValueChange={(next) => setStyle(next as StampStyle)}>
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {STYLES.map((item) => (
                <SelectItem key={item} value={item}>
                  {valid ? stamp(at, item) : item}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </Field>
      </div>
    </Dialog>
  );
}
